<template>
    <span @click="onClick" style="display: inline-flex;align-items: center;">
        <kl-icon v-if="icon" :icon="icon" :size="iconSize" /><span
            :style="{ 'color': color, 'font-weight': bold ? 'bold' : '0', 'font-size': fontSize + 'px' }">{{ title
            }}</span></span>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: ""
        },
        bold: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: ""
        },
        iconSize: {
            type: Number,
            default: 20
        },
        fontSize: {
            type: Number,
            default: 12
        }
    },
    computed: {
        color() {
            switch (this.type) {
                case "success": return "#07B477";
                case "info": return "#2A7AFF";
                case "warning": return "#FF8C00";
                case "danger": return "#FF106E";
            }
            return "#0F1A3A";
        }
    },
    methods: {
        onClick(){
            this.$emit("click");
        }
    },
}
</script>
<style lang="scss" scoped>
.kl-icon {
    margin-right: 4px;
}
</style>